import * as React from "react";

import { IExternalEventEmitter } from "../../../Engine/Core/EventManagement/ExternalEvents/ExternalEventManager";

export const ExternalEventManagerContext = React.createContext<IExternalEventEmitter | undefined>(undefined);

export function useExternalEventEmitter(): IExternalEventEmitter {
    const result = React.useContext(ExternalEventManagerContext);
    if (result == undefined) {
        throw new Error("ExternalEventManager context is required");
    }
    return result;
}
